type VerticalAlign = 'top' | 'middle' | 'bottom';
type FlexAlign = 'flex-start' | 'center' | 'flex-end';

/**
 * Normalize any verticalAlign value to standard format
 */
export function normalizeVerticalAlign(
  value: string | undefined | null
): VerticalAlign {
  switch (value) {
    case 'top':
    case 'flex-start':
      return 'top';
    case 'bottom':
    case 'flex-end':
      return 'bottom';
    default:
      return 'middle';
  }
}

/**
 * Convert standard verticalAlign values to CSS flexbox values
 * Used when setting justifyContent in CSS
 */
export function verticalAlignToFlex(value: VerticalAlign): FlexAlign {
  switch (value) {
    case 'top':
      return 'flex-start';
    case 'bottom':
      return 'flex-end';
    default:
      return 'center';
  }
}
